import { render, staticRenderFns } from "./InvoiceInfo.vue?vue&type=template&id=10704476&scoped=true"
import script from "./InvoiceInfo.vue?vue&type=script&lang=js"
export * from "./InvoiceInfo.vue?vue&type=script&lang=js"
import style0 from "./InvoiceInfo.vue?vue&type=style&index=0&id=10704476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10704476",
  null
  
)

export default component.exports